<template>
  <div id="movies">
    <movie-item
      v-for="item in movies"
      v-bind:movie="item"
      v-bind:key="item.id"
    ></movie-item>
  </div>
</template>

<script>
import MovieItem from '@/components/movie.vue'
import axios from 'axios'

export default {
  components: {
    MovieItem
  },
  data() {
    return {
      movies: null
    }
  },
  mounted(){
    axios.get('/movies.json').then(response => (this.movies = response.data.movies));
  }
}
</script>
